import { subtitle } from "./styles.css";

export const Subtitle = ({
  children,
  className,
}: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h2 className={className ? `${subtitle} ${className}` : subtitle}>
    {children}
  </h2>
);

Subtitle.displayName = "Subtitle";
